var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilterMultiChip',{attrs:{"icon":"thermometer","is-text":_vm.isText,"label":_vm.$t('search-filters.relevance-score.name'),"items":_vm.items,"value":_vm.selectedValues},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }